/* eslint-disable */

import QuerystatusPivot from "./querystatusPivot.vue";

export default {
  name: "QueryStatusReport",
  components: {
   QuerystatusPivot,
  },
    methods:{
      onclosed() {
        this.$router.go(-1)
      }
    }
};